import { ISelectOptionProps } from 'components/form/types';
import { formatDate, getLeaveYears } from 'utils/helpers/formatters';
import { IInputs } from './components/types';

export const formatDataOnSubmit = (data: IInputs) => {
  const isEmployee = data.type.value.toString().includes('employee');

  let allowedWfhLeavesPerWeek = 0;
  let allowedWfhLeavesPerMonth = 0;

  if (data.wth_leaves_period?.value === 'weekly') {
    allowedWfhLeavesPerWeek = data.wth_leaves || 0;
  } else if (data.wth_leaves_period?.value === 'monthly') {
    allowedWfhLeavesPerMonth = data.wth_leaves || 0;
  }

  return {
    ...data,
    date_of_birth: data.date_of_birth && formatDate(data.date_of_birth, 'YYY-mm-dd'),
    first_working_day: data.first_working_day && formatDate(data.first_working_day, 'YYY-mm-dd'),
    last_working_day: data.last_working_day && formatDate(data.last_working_day, 'YYY-mm-dd'),
    id_card_issued_at: data.id_card_issued_at && formatDate(data.id_card_issued_at, 'YYY-mm-dd'),
    id_card_expires_at: data.id_card_expires_at && formatDate(data.id_card_expires_at, 'YYY-mm-dd'),
    type: data.type.value,
    education: data.education?.value,
    account_status: data.account_status.value,
    groups: data.groups?.map((opt: ISelectOptionProps) => opt.value) || [],
    roles: data.roles?.map((opt: ISelectOptionProps) => opt.value) || [],
    group_rights: data.group_rights?.map((opt: ISelectOptionProps) => opt.value) || [],
    working_hours: data.working_hours?.value,
    working_type: data.working_type?.value,
    leave_notice_deadline: data.leave_notice_deadline?.value,
    probation_period: data.probation_period?.value,
    probation_beneficiary: data.probation_beneficiary?.value,
    nkpd_code: data.nkpd_code?.value,
    reset_2fa: data.reset_2fa && data.reset_2fa === 'true',
    is_representative:
      typeof data.is_representative === 'boolean' ? data.is_representative : data.is_representative === 'true',
    legal_relationship: data.legal_relationship?.value,
    administrative_unit: data.administrative_unit?.value,
    position_level: data.position_level?.value,
    position_level_info: data.position_level_info?.value,
    educational_level: data.educational_level?.value,
    rang: data.rang?.value,
    monthly_salary_level: data.monthly_salary_level?.value,
    monthly_salary_level_degree: data.monthly_salary_level_degree?.value,
    individual_monthly_salary: data.individual_monthly_salary?.value,
    allowed_wfh_leaves_per_week: allowedWfhLeavesPerWeek,
    allowed_wfh_leaves_per_month: allowedWfhLeavesPerMonth,
    ...(isEmployee && {
      leave_days_1: undefined,
      leave_days_2: undefined,
      leave_days_3: undefined,
      leave_days_4: undefined,
      user_leave_days: (() => {
        const currentYear = new Date().getFullYear();
        const yearOffsets = getLeaveYears();
        return [
          {
            year: currentYear + yearOffsets[0],
            days: data.leave_days_1 || 0,
          },
          {
            year: currentYear + yearOffsets[1],
            days: data.leave_days_2 || 0,
          },
          {
            year: currentYear + yearOffsets[2],
            days: data.leave_days_3 || 0,
          },
          {
            year: currentYear + yearOffsets[3],
            days: data.leave_days_4 || 0,
          },
          {
            year: currentYear + yearOffsets[4],
            days: data.leave_days_5 || 0,
          },
        ];
      })(),
    }),
  };
};

export default formatDataOnSubmit;
